import com.soywiz.korge.scene.Module
import com.soywiz.korim.color.RGBA
import com.soywiz.korinject.AsyncInjector
import com.soywiz.korma.geom.SizeInt
import game.CgaColor
import game.scene.LoadScene

object WishlairModule : Module() {
    override val mainScene = LoadScene::class
    override val size: SizeInt = SizeInt(1280, 800)
    override val bgcolor: RGBA = CgaColor.BLACK.rgba
    override val title: String = "Wishlair"

    override suspend fun AsyncInjector.configure() {
        mapPrototype { LoadScene() }
    }
}
